import { useEffect, useState } from "react";

import { api, type Document } from "./api";

/** Ce que le professeur a devant lui en salle : des rangées de n sièges. */
const RANGEES = [2, 3, 4, 5, 6, 8];

export default function SujetQcm({ qcmId }: { qcmId: number }) {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [sieges, setSieges] = useState(4);
  const [encours, setEncours] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);

  const recharger = () =>
    api.lireDocumentsQcm(qcmId).then((liste) =>
      setDocuments(liste.filter((d) => d.type === "sujet")),
    );

  useEffect(() => {
    recharger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qcmId]);

  const composer = async () => {
    setEncours(true);
    setErreur(null);
    try {
      await api.produireSujet(qcmId, sieges);
      await recharger();
    } catch (e) {
      setErreur((e as Error).message);
    } finally {
      setEncours(false);
    }
  };

  const dernier = documents[0];

  return (
    <section className="sujet-qcm">
      <h2>Sujet</h2>
      <p className="aide">
        Un exemplaire par élève, composé dans l'ordre où vous les poserez :
        déposez-les de gauche à droite, rangée après rangée, sans rien choisir.
        Les réponses sont mélangées d'une version à l'autre, jamais les questions —
        c'est ce qui permet une grille de réponses unique, en dernière page.
      </p>

      <div className="actions">
        <label>
          Sièges par rangée{" "}
          <select value={sieges} onChange={(e) => setSieges(Number(e.target.value))}>
            {RANGEES.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
        <button type="button" onClick={composer} disabled={encours}>
          {encours ? "Composition…" : "Composer les sujets"}
        </button>
        {dernier && (
          <a className="telechargement" href={api.lienDocumentQcm(dernier.id)}>
            Télécharger le PDF
          </a>
        )}
        <a className="telechargement" href={api.lienQuestionsQcm(qcmId)}>
          Télécharger les questions (.typ)
        </a>
      </div>

      <p className="aide">
        Le fichier <code>.typ</code> rend les questions retenues au complet et
        dans l'ordre du sujet — celui d'un QCM composé depuis la banque ne
        contient que des références, illisibles seules. C'est une copie de
        travail, pour rédiger un corrigé en regard : la banque reste la source
        de vérité.
      </p>

      <p className="aide">
        La longueur des rangées est la seule chose qu'Atelier ne peut pas deviner.
        Elle sert à ce qu'aucun des huit voisins d'un élève n'ait le même sujet que
        lui — ni devant, ni derrière, ni de côté, ni en diagonale.
      </p>

      {erreur && <p className="erreur">{erreur}</p>}
    </section>
  );
}
